import { render, staticRenderFns } from "./MermaidMarkdown.vue?vue&type=template&id=e7245666"
import script from "./MermaidMarkdown.vue?vue&type=script&lang=js"
export * from "./MermaidMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports